import React from 'react';
import { translate } from 'react-i18next';
import { Button, Message } from 'semantic-ui-react';

import Utils from 'utils/Utils.js';
import {colors, fontSizes, fonts, layout, spacings, shadow} from 'style';

const style = {
    item: {
        position: 'relative',
        overflow:'hidden',
        border: '1px solid ' + colors.themeDarkGrey,
        borderRadius: '10px',
        padding: spacings.base,
        margin: spacings.small,
        minHeight: '80px',
        lineHeight: '1.5',
    },
    buttonArea: {
        position: 'absolute',
        top: '0px',
        right: spacings.small,
        display: 'inline-block',
        width: '170px',
        height: '100%',
        lineHeight: '40px',
    },
    inviteButton: {
        fontWeight: 'normal',
        backgroundColor: colors.themeBlue,
        color: '#fff',
        borderRadius: '100px',
        width: '100%',
        textAlign: 'center',
        boxShadow: shadow,
        display: 'block',
        position: 'relative',
        top: '50%',
        marginTop: '-25px',
        ...fonts.body,
        lineHeight: '1.5',
    },
    message: {
        fontWeight: 'normal',
        color: '#fff',
        margin: '0',
        borderRadius: '100px',
        width: '100%',
        textAlign: 'center',
        padding: '0 0 0 0',
        border: 'none',
        boxShadow: 'none',
        display: 'block',
        position: 'relative',
        top: '50%',
        marginTop: '-25px',
        ...fonts.body,
        lineHeight: '1.5',
        padding: '.78571429em 1.5em .78571429em',
    },
    name: {
        padding: '10px 5px 5px 10px',
        fontSize: '1.2em',
        fontWeight: 'bold',
        color: '#000',
    },
};

const InvitationItem = ({t, employee, onClickInvite}) => (
        <div style={style.item}>
            <div style={style.name}>{Utils.titleCase(employee.firstName + ' ' + employee.lastName)}</div>
            <div style={style.buttonArea} className='inviations-buttonArea'>
            {employee.companyEmployeeInvitation==null &&
                <Button style={style.inviteButton} data-id={employee.id} onClick={onClickInvite}>{t('Invite')}</Button>
            }
            {(employee.companyEmployeeInvitation!=null && employee.companyEmployeeInvitation.accepted==false) &&
                <Message style={{...style.message, ...{backgroundColor:colors.themeDarkerGrey}}}>{t('Invited')}</Message>
            }
            {(employee.companyEmployeeInvitation!=null && employee.companyEmployeeInvitation.accepted==true) &&
                <Message style={{...style.message, ...{backgroundColor:colors.themeTeal}}}>{t('Accepted')}</Message>
            }
            </div>
        </div>
);

export default translate('invitations')(InvitationItem);





// WEBPACK FOOTER //
// ./src/modules/invitations/InvitationItem.js